import {useEffect, useState} from 'react';

const getVoltaxPlayer = (playerName) => {
  if (!window.voltax) {
    return null;
  }

  const players = playerName
    ? window.voltax.getPlayersByName(playerName)
    : window.voltax.getAllPlayersOnPage();

  return players?.[0] ?? null;
};

// Resolves the Voltax player instance once the engine is available.
// If `window.voltax` is already present, the player is returned immediately;
// otherwise we wait for the `voltaxPlayerLoaded` event from the Voltax docs.
export const useVoltaxPlayer = (playerName) => {
  const [player, setPlayer] = useState(() => getVoltaxPlayer(playerName));

  useEffect(() => {
    const existingPlayer = getVoltaxPlayer(playerName);
    if (existingPlayer) {
      setPlayer(existingPlayer);
      return;
    }

    const handleVoltaxPlayerLoaded = ({detail}) => {
      const name = playerName || detail?.playerName;
      const loadedPlayer = getVoltaxPlayer(name);
      if (loadedPlayer) {
        setPlayer(loadedPlayer);
      }
    };

    window.addEventListener('voltaxPlayerLoaded', handleVoltaxPlayerLoaded);

    return () => {
      window.removeEventListener('voltaxPlayerLoaded', handleVoltaxPlayerLoaded);
    };
  }, [playerName]);

  return player;
};
